import { render, staticRenderFns } from "./CampoPais.vue?vue&type=template&id=2f663b0c"
import script from "./CampoPais.vue?vue&type=script&lang=js"
export * from "./CampoPais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports